function removeTypename(data) {
  if (Array.isArray(data)) {
    return data.map(removeTypename);
  } else if (data && typeof data === 'object') {
    const convertedData = {};
    Object.keys(data).forEach((key) => {
      if (key !== '__typename') {
        convertedData[key] = removeTypename(data[key]);
      }
    });
    return convertedData;
  }
  return data;
}

export default removeTypename;



// WEBPACK FOOTER //
// ./src/byob-cms/src/removeTypename.js